import type { OsobyKomunikacniUdajeDto } from '@gov-nx/api';
import { useRezaSelection } from '../Reza/useRezaSelection';
import { useRobCommunicationQuery } from './query/useRobCommunicationQuery';
import { useRosCommunicationQuery } from './query/useRosCommunicationQuery';
import { first } from '@gov-nx/core/types';

export const useContactDetailsByReza = ({
	isBusinessPersonAllowed,
}: {
	isBusinessPersonAllowed: boolean;
}): OsobyKomunikacniUdajeDto | undefined => {
	const { isRezaSelected } = useRezaSelection();
	const { data: robData } = useRobCommunicationQuery();
	const { data: rosData } = useRosCommunicationQuery({
		isEnabled: isBusinessPersonAllowed,
	});

	if (!isBusinessPersonAllowed) {
		return robData;
	}

	return isRezaSelected
		? first(rosData?.seznam ?? [])?.komunikacniUdaje
		: robData;
};
